<template>
  <el-button-group style="display: inline-block;">
    <el-tooltip class="item" effect="dark" :content="departmentData.export.code" placement="top" v-if="departmentData.export.show">
      <el-button size="mini" type="primary" icon="iconfont icon-dingdan" @click="getTemplateAction"></el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" :content="departmentData.import.code" placement="top">
      <span style="position: relative; padding:0px 7px;background:#0063be;margin:0 0 0 2px;border-radius:0 4px 4px 0;vertical-align: initial;display: inline-block;line-height: 28px;">
        <i class="iconfont icon-shangchuan-kong" style="color:#fff;"></i>
        <input type="file" id="input" ref="pathClear" @change="getFile($event)" style="position: absolute;top: 0;left: 0;opacity:0;width:30px;line-height:23px;filter:Alpha(opacity=0);border:1px solid #f00" />
      </span>
    </el-tooltip>
  </el-button-group>
</template>

<script>
//通用模板下载，导入数据
import * as API from '@/api/apiBase';
  export default {
    name: 'excelImport',
    props: ['departmentData','temFlag','temPost',"GetPostData",'importFlag'],
    data() {
      return {
        fullscreenLoading: false
      }
    },
    created() {
      
    },
    mounted() {
    },
    methods: {
      //清空input值
      /*清空input file 里面所选择内容*/
      clearFileAction(){
        this.$refs.pathClear.value =''
      },
      leave(){
      },
      showInput(){
      },
      /*下载模板*/
      getTemplateAction() {
        //下载模板 参数（apiURL,文件类型），文件类型根据minetype
        this.downloadPostTem(this.departmentData.export.apiUrl,this.departmentData.export.fileType);
      },
      /*选取文件*/
      async getFile(param) {
        let file = param.target.files[0]
        let fileName=file.name
        let fileTypeName=fileName.substr(fileName.lastIndexOf('.'),fileName.length)
        if(fileTypeName!='.xls'&&fileTypeName!='.xlsx'){
          this.$message.error(this.$t('message.FileTips'));
          this.clearFileAction()
          return
        }
        let formData = new FormData()
        formData.append('file', file)
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        const loading = this.$loading({
          lock: true,
          text: this.$t('message.ImportLoading'),
          background: 'rgba(0, 0, 0, 0.8)'
        })
        let data = await API.POST(this.departmentData.import.apiUrl, formData,config)
        loading.close()
        if (data.error_code === '0') {
          this.$emit('event1', data.data)
        } else {
          this.clearFileAction()
        }
      }
    }
  }
</script>

<style scoped>
</style>
